"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _reactRedux = require("react-redux");
var _publisherConsentsSlice = require("../../redux/publisherConsentsSlice");
var _ConsentsStyled = require("./ConsentsStyled");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var regexHrefOpenTag = new RegExp(/<a(.|\n)*?>/);
var regexHrefCloseTag = new RegExp(/<\/a(.|\n)*?>/);
var Consents = function Consents(_ref) {
  var error = _ref.error,
    onChangeFn = _ref.onChangeFn,
    t = _ref.t;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.publisherConsents;
    }),
    publisherConsents = _useSelector.publisherConsents,
    checked = _useSelector.checked,
    loading = _useSelector.loading,
    generalError = _useSelector.error;
  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
      return state.publisherConfig;
    }),
    publisherId = _useSelector2.publisherId;
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    function getConsents() {
      return _getConsents.apply(this, arguments);
    }
    function _getConsents() {
      _getConsents = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!publisherId) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return dispatch((0, _publisherConsentsSlice.fetchPublisherConsents)(publisherId));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _getConsents.apply(this, arguments);
    }
    getConsents();
  }, [publisherId]);
  (0, _react.useEffect)(function () {
    // validate consents
    onChangeFn(checked, publisherConsents);
  }, [checked, publisherConsents]);
  var translateConsents = function translateConsents(consentContent) {
    var openTagContent = regexHrefOpenTag.exec(consentContent);
    var closeTagContent = regexHrefCloseTag.exec(consentContent);
    if (openTagContent) {
      var modifiedConsentContent = consentContent.replace(regexHrefOpenTag, '{{htmltag}}');
      modifiedConsentContent = modifiedConsentContent.replace(regexHrefCloseTag, '{{endhtmltag}}');
      return "".concat(t(modifiedConsentContent, {
        htmltag: openTagContent[0],
        endhtmltag: closeTagContent[0]
      }));
    }
    return t(consentContent);
  };
  if (generalError === 'noPublisherId') {
    return /*#__PURE__*/_react.default.createElement(_ConsentsStyled.GeneralErrorStyled, {
      "data-testid": "consents__general-error"
    }, t('Unable to fetch terms & conditions. Publisher is not recognized'));
  }
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_ConsentsStyled.ConsentsWrapperStyled, {
      "data-testid": "consents__loader"
    }, /*#__PURE__*/_react.default.createElement(_Loader.default, null));
  }
  return /*#__PURE__*/_react.default.createElement(_ConsentsStyled.ConsentsWrapperStyled, null, /*#__PURE__*/_react.default.createElement(_ConsentsStyled.FieldsetStyled, null, /*#__PURE__*/_react.default.createElement(_ConsentsStyled.InvisibleLegend, null, "Consents "), publisherConsents.map(function (consent, index) {
    return /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onClickFn: function onClickFn() {
        return dispatch((0, _publisherConsentsSlice.setChecked)(index));
      },
      checked: checked[index],
      error: error,
      key: consent.label,
      required: consent.required && !checked[index]
    }, translateConsents(consent.label) + (consent.required ? '*' : ''));
  })), error && /*#__PURE__*/_react.default.createElement(_ConsentsStyled.ConsentsErrorStyled, null, error));
};
Consents.propTypes = {
  error: _propTypes.default.string,
  onChangeFn: _propTypes.default.func,
  t: _propTypes.default.func
};
Consents.defaultProps = {
  error: '',
  onChangeFn: function onChangeFn() {},
  t: function t(k) {
    return k;
  }
};
var _default = Consents;
exports.default = _default;